export default "__VITE_ASSET__D3xZ6oLY__"